import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Plus.svg'

export const IconPlus = IconSVG as IconComponent
